<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="pd-b-4 flex-display js-between change-display">
      <div class="text-left">
        <h2 class="mg-less">งานที่ได้รับมอบหมาย (Assignment) </h2>
        <div class="flex-display">
          <p class="text-font-14">
            <span class="text-weight-bold">หลักสูตร </span
            ><span class="color-gray">{{ course.name }}</span>
          </p>
          <p class="text-font-14 pd-l-4 text-break-word "> <span class="text-weight-bold">วิชาที่</span> {{subject.index}} <span class="color-gray">{{ subject.name }}</span></p>
        </div>
        
      </div>
      <div class="flex-display js-end ai-end search-download">
        <el-form @submit.prevent.native @keyup.enter.native="search">
          <el-input
            placeholder="ค้นหารายชื่อ"
            prefix-icon="el-icon-search"
            class="search-input"
            @blur="showInputSearch = false,!searchText && showSearch?search():null"
            @keyup.enter.native="search"
            @clear="searchText = '',search()"
            :class="{ show: showInputSearch }"
            ref="search"
            clearable
            v-model="searchText"
          >
          </el-input>

          <el-button
            v-if="!showInputSearch"
            @click="openSearchInput"
            icon="el-icon-search"
            round
            class="pd-x-2 primary border-color-primary"
            >ค้นหา</el-button
          >
        </el-form>
      </div>
    </div>

    <ActivitySummaryStatusList 
      v-loading="loading" 
      :nameList="nameList" 
      labelScore="งานที่ได้รับมอบหมาย" 
      scopeField="assignment" 
      :courseId="courseId" 
      :subjectId="subjectId" 
      @checkAssignment="checkAssignment"/>

    <div v-if="totalNameList > 10" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalNameList"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySummaryStatusList from "@/components/activity/ActivitySummaryStatusList";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    ActivitySummaryStatusList,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      loading:true,
      activeName: "1",
      courseId: "",
      subjectId: "",
      searchText: "",
      showInputSearch: false,
      course: "",
      subject: "",
      nameList: [],
      page: 1,
      pageSize: 10,
      totalNameList:0,
      showSearch:false
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentScore();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.subjectId = this.routeParams.subjectId;
          if (typeof this.routeParams.tab != "undefined") {
            this.activeName = this.routeParams.tab
          }
        }
      }
    },
    fetchStudentScore() {
      let obj = {
        courseId:this.courseId,
        subjectId:this.subjectId,
        page:(this.page - 1) * this.pageSize,
        limit:this.pageSize,
        search:this.searchText
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student/score/subject`, obj)
        .then((res) => {

          if (res.data.success) {
            this.nameList = res.data.obj;
            this.totalNameList = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentScore error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    checkAssignment(userId,subjectId, status) {
      this.loading = true;

      let obj = {
        subjectId: subjectId,
        userId: userId,
        status: status == 100?false:true,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`check/assignment`, obj)
        .then((res) => {
          
          if (res.data.success) {
            this.fetchStudentScore();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("checkAssignment error", e);
        });
    },
    changePage(page) {
      this.page = page;
    },
    changeTab() {
      this.page = 1;
    },
  },
};
</script>